import { BRAND_HOSTS, REGUS } from 'src/app/shared/constants/brands.constants';

export const getLocationsSearchString = (): string => {
  if (window.location.search) {
    return window.location.search.substring(0, window.location.search.lastIndexOf('#'));
  }

  const hash = window.location.hash;
  const section = hash.slice(1).split('#')[0]; // remove fragment

  return section.split('?')[1] ?? '';
};

export const getLangFromLocale = (params): string => {
  const locale = params.locale;
  // 'en' as default fallback lang
  return locale ? (locale.split('-')[0] || 'en') : 'en';
};

const BASE_PATH_SEGMENTS = ['booking', 'booking-rd'];

export const getCulturePart = (): string | undefined => {
  const fromPath = window.location.pathname
    .split('/')
    .filter(part => (part.length && !BASE_PATH_SEGMENTS.includes(part)))[0];
  if (fromPath) return fromPath.split('-')[0];
  const hashQuery = window.location.hash.split('?')[1] ?? '';
  const locale = new URLSearchParams(hashQuery).get('locale');
  return locale ? locale.split('-')[0] : undefined;
};

export const formatLink = (link: string): string => {
  const culturePart = getCulturePart();
  return `${location.protocol}//${location.host}/${culturePart ? culturePart + '/' : ''}${link}`;
}

export const navigateToHome = (currentBrand: string): void => {
  const hostname = window.location.hostname.toLowerCase();
  const isLocalEnv = hostname === 'localhost' || hostname === 'localdev' || hostname.includes('127.0.0.1');

  const culturePart = getCulturePart();
  const langPrefix = culturePart ? `/${culturePart}` : '';
  let destinationUrl: string;

  if (isLocalEnv) {
    const brandHost = BRAND_HOSTS[currentBrand] || BRAND_HOSTS[REGUS];
    destinationUrl = `https://${brandHost}${langPrefix}`;
  } else {
    destinationUrl = `${window.location.origin}${langPrefix}`;
  }

  window.location.href = destinationUrl;
};
